export const useSelectedTimeslot = (selectedTimeslot: string | null) => {
    if (!selectedTimeslot) {
        return {
            time: '00:00'
        }
    }

    const date = new Date(selectedTimeslot);

    const hours = `0${date.getHours()}`.slice(-2);
    const minutes = `0${date.getMinutes()}`.slice(-2);

    return {
        time: `${hours}:${minutes}`,
    }
}